import React from 'react'

export const UserIcon = ({
  color = '#AC0AE8',
  width = 24,
  height = 24,
  style = {}
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle cx="12" cy="12" r="12" fill={color} />
      <circle cx="12" cy="8.25" r="3.75" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.78027 18C5.51288 15.2938 8.54573 13.5 11.9975 13.5C15.4494 13.5 18.4822 15.2938 20.2148 18C18.4822 20.7062 15.4494 22.5 11.9975 22.5C8.54573 22.5 5.51288 20.7062 3.78027 18Z"
        fill="white"
      />
    </svg>
  )
}
